import EfImgListA from '@elem/ui/ef-img-list-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTabHoverA from '@elem/ui/ef-tab-hover-a';
import { PRODUCT_PB5000, PRODUCT_PB10000 } from '../../index';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionI');

    const itemsA = [
        {
            title: t('a_item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724047224135/rapid_01.jpg',
        },
        {
            title: t('a_item2'),
            desc: t('a_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723789480274/rapid_02.jpg',
        },
        {
            title: t('a_item3'),
            desc: t('a_item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723789480694/rapid_03.jpg',
        },
        {
            title: t('a_item4'),
            desc: t('a_item4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724047224392/rapid_04.jpg',
        },
        {
            title: t('a_item5'),
            desc: t('a_item5_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723789480878/rapid_05.jpg',
        },
    ];

    const itemsB = [
        {
            tabName: t('a_tab'),
            pc: PRODUCT_PB5000,
            label: t('a_label'),
            title: t('a_title'),
            descList: [t('a_desc1'), t('a_desc2'), t('a_desc3')],
        },
        {
            tabName: t('b_tab'),
            pc: PRODUCT_PB10000,
            label: t('b_label'),
            title: t('b_title'),
            descList: [t('b_desc1'), t('b_desc2'), t('b_desc3')],
        },
    ];

    return (
        <div className={styles.TheComp} id="section-SectionI">
            <EfSpec />
            <EfSection title={t('title')} desc={t('desc')} />
            <EfImgListA items={itemsA} />
            <EfTabHoverA items={itemsB} />
        </div>
    );
}
